import React, { useEffect, useImperativeHandle, useState } from "react";
import { AwsUpdate } from "../../../../utils/tool";

export default function FileUploader(props) {
    // useRef
    const [uploading, setUploading] = useState(false) // 上传中
    const [uploadPercent, setUploadPercent] = useState(0) // 上传进度
    // const [uploadImg, setUploadImg] = useState('https://picx.zhimg.com/v2-cba0b89d2bf2d96a1ed26edb5849f804_qhd.jpg?source=172ae18b') // 上传之后的图片地址
    const [uploadImg, setUploadImg] = useState('') // 上传之后的图片地址

    useEffect(() => {
        if (props.url && props.url !== uploadImg) {
            console.log('props', props)
            setUploadImg(props.url)
        }
    }, [props, uploadImg])

    const handleFileInput = (e) => {
        // handle validations
        const file = e.target.files[0]

        if (props.onBeforeUpload) {
            if (!props.onBeforeUpload(file)) {
                return
            }
        }

        let k = Date.now() + "" + file.name;
        console.log(e.target.files[0])
        setUploadImg('')
        setUploading(true)
        AwsUpdate(file, k, (x) => {
            const percent = Math.round((x.loaded / x.total) * 10000) / 100;
            console.log("上传进度是", percent, "%");
            setUploadPercent(percent)
        }).then((x) => {
            console.log("上传之后的结果是", x);
            setUploadImg(x.Location)
            setUploading(false)
            props.onFileUpload && props.onFileUpload(x.Location)
        }).catch(e => {
            console.log('上传失败', e)
            setUploading(false)
        })
        props.onFileSelect && props.onFileSelect(e.target.files[0])
    }

    return (<>
        <div style={{ 'width': props.width, 'minHeight': props.height }} className="stake-file-uploader">
            <input
                type="file" onChange={handleFileInput} />
            {!uploadImg && <div className="stake-file-uploader-box">
                {uploading && <div className="stake-file-uploader-box-loading">
                    <div>
                        <i style={{ 'fontSize': '20px' }} className="fa fa-spinner loading-css"></i>
                    </div>
                    <div>
                        {uploadPercent}%
                    </div>

                </div>}

                {!uploading && '+'}
            </div>}
            {uploadImg && <div className="stake-file-uploader-box">
                <img src={uploadImg} className="stake-file-uploader-box-img" alt="" />
            </div>}
        </div>
    </>)
}